"use client";

import type { IconicVoicesTableBlock } from "@mw/shared/payload-types";

import { filterEntitiesArray } from "@utilities/payload";
import dynamic from "next/dynamic";

const IconicVoicesTable = dynamic(() => import("./IconicVoicesTable").then(mod => mod.IconicVoicesTable));

export const IconicVoicesTableClient = (props: IconicVoicesTableBlock) => {
  return <IconicVoicesTable {...props} voices={filterEntitiesArray(props.voices || [])} />;
};
